export default "__VITE_ASSET__f59d704c__"